import cn from 'classnames';
import { useIntersectionObserver, useWindowSize } from 'usehooks-ts';

import FilterOption from '@publicImages/svg/filters.svg?static';

import UIResource from '@/components/UIResource';
import getFocusableElements from '@/ducks/a11y/helpers/getFocusableElements';
import { setFiltersModalOpen } from '@/ducks/pages/chooseVoyage/slice';
import { useAppDispatch } from '@/store';
import tagmanager from '@/tagmanager';

import styles from './SearchAgainButton.module.scss';

const filtersRowId = 'ResultRefinements__newFilterPrimaryRow';
const SearchAgainButton = () => {
  const dispatch = useAppDispatch();
  const { width } = useWindowSize();

  const onSearch = () => {
    tagmanager.tracker.voyagesFilter.trackReApplyFilters();

    if (width < 768) {
      dispatch(setFiltersModalOpen(true));
      return;
    }

    const target = document.getElementById(filtersRowId);
    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    const focusable = getFocusableElements(target);
    focusable[0]?.focus();
  };

  return (
    <button className={styles.button} onClick={onSearch}>
      <FilterOption className={styles.icon} />
      <span className={styles.text}>
        <UIResource id="ChooseVoyage.SearchAgain.button" />
      </span>
    </button>
  );
};

export const SearchAgainButtonContainer = ({ children, className, ...props }: React.ComponentProps<'div'>) => {
  const [ref, isInView] = useIntersectionObserver({ rootMargin: '0px 0px -500px 0px' });

  return (
    <div className={cn(isInView && styles.show, className)} ref={ref} {...props}>
      {children}
      <SearchAgainButton />
    </div>
  );
};
